import { chatApi } from "./chatClient";
import type { AttachmentRef, CursorPage, Mention, Message } from "./types";

export interface ListMessagesParams {
  cursor?: string | null;
  limit?: number;
  mentions_me?: boolean;
}

export interface CreateMessageBody {
  body: string;
  attachments?: AttachmentRef[];
  mentions?: Mention[];
  parent_message_id?: string | null;
  quoted_message_id?: string | null;
}

function qs(params: Record<string, string | number | boolean | undefined | null>): string {
  const entries = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== null && v !== "",
  ) as [string, string | number | boolean][];
  return entries.length ? `?${new URLSearchParams(entries.map(([k, v]) => [k, String(v)]))}` : "";
}

export const messagesService = {
  list: (conversationId: string, params: ListMessagesParams = {}) =>
    chatApi.get<CursorPage<Message>>(`/conversations/${conversationId}/messages/${qs(params as Record<string, string | number | boolean | undefined | null>)}`),

  retrieve: (id: string) => chatApi.get<Message>(`/messages/${id}/`),

  create: (conversationId: string, body: CreateMessageBody) =>
    chatApi.post<Message>(`/conversations/${conversationId}/messages/`, body),

  update: (conversationId: string, id: string, body: { body: string }) =>
    chatApi.patch<Message>(`/conversations/${conversationId}/messages/${id}/`, body),

  destroy: (conversationId: string, id: string) =>
    chatApi.delete<void>(`/conversations/${conversationId}/messages/${id}/`),
};
